module.exports = __webpack_public_path__ + "static/img/store-active.fa12d25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/store-active.png
// module id = ICOI
// module chunks = 26